module.exports = __webpack_public_path__ + "assets/img/discernment_car_scene2.65bcce6b.png";